var _a;
import { i18nConfig } from '../../../i18n';
import uaTool from '../../../util/uatool';
/**
   * 返回当前环境是否支持audioControl
   * @returns 是否支持audioControl
   */
export function isEnvSupport() {
    if (!window.AudioContext && !window.webkitAudioContext) {
        return false;
    }
    // safari不支持WebAudio音效
    if (uaTool.browser.safari) {
        return false;
    }
    return true;
}
/** 根据effectName查找对应的AudioPreCfg */
export function getPreCfgByName(effectName, cfgList) {
    var cpsCfg = cfgList.find(function (preCfg) { return preCfg.name === effectName; });
    return cpsCfg;
}
/**
 * 分贝到gainNode值转换
 * @param db 分贝值
 * @returns gainNode的对应增益值
 */
export function dbToGainValue(db) {
    return Math.pow(10, (db / dbConstant));
}
/**
 * 分贝到gainNode值转换
 * @param gainValue gainNode的对应增益值
 * @returns 分贝值
 */
export function gainValueToDb(gainValue) {
    return Math.log(gainValue) / Math.LN10 * dbConstant;
}
/** 分贝转换常量 */
export var dbConstant = 20;
/** 音频效果名，用于指定音频效果 */
export var AUDIO_EFFECT_NAME;
(function (AUDIO_EFFECT_NAME) {
    /** 默认无附加效果 */
    AUDIO_EFFECT_NAME["DEFAULT"] = "default";
    /** 空间环绕立体声 */
    AUDIO_EFFECT_NAME["SPATIAL_STEREO"] = "spatial_stereo";
    /** 重低音 */
    AUDIO_EFFECT_NAME["BASE_BOOSTER"] = "base_booster";
    /** 强化人声 */
    AUDIO_EFFECT_NAME["VOCAL_BOOSTER"] = "vocal_booster";
    /** 弱化人声 */
    AUDIO_EFFECT_NAME["VOCAL_WEAK"] = "vocal_weak";
    /* 流行 */
    AUDIO_EFFECT_NAME["POP"] = "pop";
    /** 古典 */
    AUDIO_EFFECT_NAME["CLASSICAL"] = "classcal";
    /** 电子音乐 */
    AUDIO_EFFECT_NAME["ELECTRONIC"] = "electronic";
    /** 吉他 */
    AUDIO_EFFECT_NAME["GUITAR"] = "guitar";
    /** 嘻哈 */
    AUDIO_EFFECT_NAME["HIPHOP"] = "hiphop";
    /** 爵士 */
    AUDIO_EFFECT_NAME["JAZZ"] = "jazz";
    /** R&B */
    AUDIO_EFFECT_NAME["RNB"] = "rnb";
    /** 摇滚 */
    AUDIO_EFFECT_NAME["ROCK_N_ROLL"] = "rocknroll";
    /** 音乐厅模式 */
    AUDIO_EFFECT_NAME["CONCERT_HALL"] = "concert_hall";
    /** 现场 */
    AUDIO_EFFECT_NAME["LIVE"] = "live";
    /** 客厅 */
    AUDIO_EFFECT_NAME["LIVING_ROOM"] = "living_room";
})(AUDIO_EFFECT_NAME || (AUDIO_EFFECT_NAME = {}));
;
/** 音频效果中文名，用于展示内容 */
export var AUDIO_EFFECT_CNNAME = (_a = {},
    _a[AUDIO_EFFECT_NAME.DEFAULT] = i18nConfig.core.INFO_AUDIO_EFFECT_DEFAULT,
    _a[AUDIO_EFFECT_NAME.SPATIAL_STEREO] = i18nConfig.core.INFO_AUDIO_EFFECT_SPATIAL_STEREO,
    _a[AUDIO_EFFECT_NAME.BASE_BOOSTER] = i18nConfig.core.INFO_AUDIO_EFFECT_BASE_BOOSTER,
    _a[AUDIO_EFFECT_NAME.VOCAL_BOOSTER] = i18nConfig.core.INFO_AUDIO_EFFECT_VOCAL_BOOSTER,
    _a[AUDIO_EFFECT_NAME.VOCAL_WEAK] = i18nConfig.core.INFO_AUDIO_EFFECT_VOCAL_WEAK,
    _a[AUDIO_EFFECT_NAME.POP] = i18nConfig.core.INFO_AUDIO_EFFECT_POP,
    _a[AUDIO_EFFECT_NAME.CLASSICAL] = i18nConfig.core.INFO_AUDIO_EFFECT_CLASSICAL,
    _a[AUDIO_EFFECT_NAME.ELECTRONIC] = i18nConfig.core.INFO_AUDIO_EFFECT_ELECTRONIC,
    _a[AUDIO_EFFECT_NAME.GUITAR] = i18nConfig.core.INFO_AUDIO_EFFECT_GUITAR,
    _a[AUDIO_EFFECT_NAME.HIPHOP] = i18nConfig.core.INFO_AUDIO_EFFECT_HIPHOP,
    _a[AUDIO_EFFECT_NAME.JAZZ] = i18nConfig.core.INFO_AUDIO_EFFECT_JAZZ,
    _a[AUDIO_EFFECT_NAME.RNB] = i18nConfig.core.INFO_AUDIO_EFFECT_RNB,
    _a[AUDIO_EFFECT_NAME.ROCK_N_ROLL] = i18nConfig.core.INFO_AUDIO_EFFECT_ROCK_N_ROLL,
    _a[AUDIO_EFFECT_NAME.CONCERT_HALL] = i18nConfig.core.INFO_AUDIO_EFFECT_CONCERT_HALL,
    _a[AUDIO_EFFECT_NAME.LIVE] = i18nConfig.core.INFO_AUDIO_EFFECT_LIVE,
    _a[AUDIO_EFFECT_NAME.LIVING_ROOM] = i18nConfig.core.INFO_AUDIO_EFFECT_LIVING_ROOM,
    _a);
